import angular from 'angular';
import template from './template.jade';
import './styles.styl';

const CountdownTimer = function (element, time, name, onFinish) {
	if (time <= 0) {
		throw new Error(`Time param should be more than 0.`);
	}

	const getNextUniqueId = () => `$countdownTimer${CountdownTimer.counter++}`;

	const timeTotal = time;
	this.name = name || getNextUniqueId();
	let interval = null;

	const tick = () => {
		time -= 1;
		element.text(time);
	};

	this.start = () => {
		if (interval) {
			this.clear();
		}
		tick();
		interval = setInterval(() => {
			tick();
			if (time <= 0) {
				this.clear();
				if (onFinish) {
					onFinish();
				}
			}
		}, 1000);
	};

	this.clear = () => {
		if (interval) {
			clearInterval(interval);
		}
		interval = null;
		time = timeTotal;
	};
};
CountdownTimer.counter = 0;

export default angular
	.module('ui.cian.countdown', [])
	.factory('cianUiCountdownService', () => {
		const countdownTimers = {};

		return {
			create: (element, time, name, onFinish) => {
				if (countdownTimers[name]) {
					throw new Error(`Countdown timer called ${name} is already registered.`);
				}
				const countdownTimer = new CountdownTimer(element, time, name, onFinish);
				countdownTimers[countdownTimer.name] = countdownTimer;
				countdownTimer.start();
				return countdownTimer;
			},
			start: countdownTimerName => {
				countdownTimers[countdownTimerName].start();
			}
		};
	})
	.directive('cianUiCountdown', ['cianUiCountdownService', cianUiCountdownService => ({
		restrict: 'E',
		scope: {},
		bindToController: {
			name: '@',
			time: '@',
			onFinish: '&'
		},
		controller: ['$element', '$scope', function ($element, $scope) {
			const time = parseInt(this.time, 10);

			const onFinish = () => $scope.$apply(this.onFinish);

			const countdownTimer = cianUiCountdownService.create($element, time, this.name, onFinish);

			$scope.$on('$destroy', () => {
				countdownTimer.clear();
			});
		}],
		controllerAs: 'countdown',
		replace: true,
		template
	})])
	.name;
